import { Card, CardContent } from "src/components/ui/card";
import { Avatar } from "antd";
import { Badge } from "src/components/ui/badge";
import { useLanguage } from "../../../../../../context/LanguageContext";

export function LevelCard({ level, isSelected, onSelect }) {
  const { language } = useLanguage();

  return (
    <Card
      key={level.id}
      className={`cursor-pointer transition-colors ${
        isSelected ? "border-blue-600" : "hover:border-blue-600"
      }`}
      onClick={onSelect}
    >
      <CardContent className="p-6 flex flex-col items-center text-center">
        <h3 className="text-lg font-semibold mb-1">
          {level.title[language] || level.title.en || level.title.ar}
        </h3>

        <p className="text-sm text-muted-foreground mb-2">
          {level.description?.[language] || level.description?.en}
        </p>

        <p className="text-xs text-gray-500 mb-1">
          <strong>Created by:</strong> {level.created_by?.name || "N/A"}
        </p>

        <div className="mt-2">
          <Badge
            variant="secondary"
            className="bg-blue-100 text-blue-800 hover:bg-blue-200"
          >
            Groups: {level.groups_count}
          </Badge>
        </div>
      </CardContent>
    </Card>
  );
}
